import React, { Fragment } from 'react';
import { Layer, Stage, Image, Rect,} from 'react-konva';
import './Canvas.css';
import assets from './assets';
import Desktop from './5_desktop';

import {
  canvasTopDevelopmentLocalHost,
  canvasSideMargin,
  userIsLoggedIn,
  isDevelopment,
  isSeinfeld,
  minimal,
  isRtl,
  // footerHeight,
  androidTabletBottomBar,
  dualPedigreeMode,
  dualPedigreeLaunchOnDev,
  flipPanelWidth,
  dualPedigreeBackgroundHash,
  stageDualPedigreeSizeObj,
  defaultBackgroundTextureFileName,
  isSafari,
  defaultFanChartStagePos
} from '../../library/constants';
import {
  isChrome,
  isFireFox,
  isIE,
  isAndroidTablet,
  isLandscape,
  isAndroidPhone,
  isMobilePhone,
  debugStageCurrent,
  sortVisitedByValue,
  doWhenReady,
  addEvent,
  filterQuestionMarkFromURL,
  parseOutLastSegmentOfUrl,
  urlGet,
  isEmptyObject,
  enableContextMenuForGeni,
  // isMobileTablet,
} from '../../library/calc';

import NotificationSystem from 'react-notification-system'; //http://igorprado.com/react-notification-system/. & https://github.com/igorprado/react-notification-system
import RedrawCanvasTree from '../../components/RedrawCanvasTree';

import FanChart from '../../components/FanChart';

import { ProgressIndicator, ProgressBar } from '../../components/ProgressIndicator';

export class Canvas extends Desktop {

  componentDidMount(){

    document.getElementById("debugDiv4").innerHTML = `mob ? ${ (isMobilePhone() ? 'true': 'false') }`;

    if(!isDevelopment) this.showProgressIndicator();
    if(isSeinfeld ||  urlGet('rightclickable') === 'true'){
      enableContextMenuForGeni();
    }

    this.visitedCount++; this.visited['componentDidMount'] = this.visitedCount;

    this.exposeForDev();
    this.exposeForProd();

    // this.stage.current.container().addEventListener('click', (e) => {
    //   // console.log('stage/addEventListener/click');
    // });

    if( this.stage.current ){ this.currentNotNull = true;} else {this.currentNotNull = false;}
    if( typeof(this.stage.current) !== 'undefined' ) {this.currentIsDefined = true;} else {this.currentIsDefined = false;}

    const fromWhere = 'componentDidMount';
    const logExceptionAndRun = debugStageCurrent(function(stageCurrent, fromWhere) {

      stageCurrent.container().style.cursor = 'pointer';
      // stageCurrent.container().addEventListener('click', (e) => {
      //   console.log('Clicked Stage Canvas');
      // });

    }, fromWhere).bind(this);

    logExceptionAndRun();


    this.setInitialPlaceHolders();
    this.setCustomStylesForTree({});
    this.setOptionsForTree({})
    if(!isMobilePhone()) this.bindDesktopEvents();
    if(isMobilePhone()) this.bindHashChange();
    this.bindMobileEvents();
    if(!isMobilePhone()) this.defineWindowCanvasRefObj();
    this.getTranslationForLabels();
    this.bindRefs();
    if(isRtl){
      document.body.style.direction = "rtl";
    }
    this.allowComponentUpdate(true);

    const deviceIs = {
      isSafari,
      isChrome: isChrome(),
      isFireFox: isFireFox(),
      isIE: isIE(),
      isAndroidTablet: isAndroidTablet(),
      isLandscape: isLandscape(),
      isAndroidPhone: isAndroidPhone()};

    this.debugOrder++;
    this.debugObj['OS'] = {order: this.debugOrder, 'deviceIs': deviceIs};


    // // if(isDevelopment) return;
    // if( dualPedigreeMode){
    //   console.log('dualPedigreeMode');
    //   this.bindWindowEvents();
    //   this.componentUpdateAfterStateFirstHasTree = true;
    //   if(!isMobilePhone()) this.bindStageEvents();
    //   return;
    // }


    const waitForChartType = () => {
      return (this.props.chartType && this.stage.current);
    }

    const chartTypeIsReady = () => {


     if( this.props.chartType !== 'fan'){

        this.bindWindowEvents();
        if(!isMobilePhone()) this.bindStageEvents();

     } else {


        this.bindFanChartStageEvents();

        addEvent(window, "popstate", (event) => {

          let urlAddress = window.location.href;

          if( urlAddress.includes('#') ) return;
          urlAddress = filterQuestionMarkFromURL(urlAddress);

          const prId = parseOutLastSegmentOfUrl(urlAddress);
          this.refocusFanChart({prId});

        });

     }

    }

    doWhenReady({argument: '', condition: waitForChartType, callback: chartTypeIsReady, attempts: {ongoing:0, end: 99999999999}, fromWhere: 'applyAlternateColorShadingToNavigationGotoCols'})

    return;

        // Include below to test public warning notification on dev

        // if(!isDevelopment) return;
        // setTimeout(() => {
        //   window.callReloadCanvasTree('13038', {prIdToTeleport:'79533', warnPublic:true});
        //   setTimeout(() => {
        //       window.callHideProgressIndicator();
        //   }, 1000);
        // }, 1000);

  }

  componentDidUpdate(prevProps, prevState){

    this.visitedCount++; this.visited['componentDidUpdate'] = this.visitedCount;

      if( this.props.chartType !== 'fan'){

        if(this.componentUpdateAfterStateFirstHasTree && !this.didOnlyOnceAfterStateHasTree){
          this.didOnlyOnceAfterStateHasTree = true;
          this.doAfterInitialComponentUpdateAfterStateHasTree();
        }

        if(typeof(this.props.focusNode) === 'undefined' ||
          typeof(this.nodeObjs) === 'undefined' ||
          typeof(this.nodeObjs[this.props.focusNode]) === 'undefined' ) {
          return;
        }

        if( this.state.pushToHistory){
          this.pushToHistoryAfterComponentUpdate();
        }

        if( this.isContinueFromReloadwithNewTree() ) {
          this.continueFromReloadwithNewTree();
        }

      }
      else {

        if(!this.didOnlyOnceAfterStateHasTree){
          this.didOnlyOnceAfterStateHasTree = true;
          this.calcNewStageCenterNodePos()
          this.nodeObjs = window.nodeObjs = this.props.nodeObjs;
          this.props.fetchPreferences({});
          this.showNavigationalControls();

          // if(!isDevelopment) this.fetchFlosaters();

          const href = window.location.href;
          const hashPrId = href.split('#')[1];
          const resolveFocusPrId = href.split('?resolve=')[1];
          const needToResolveAndPopModal = () => {
            return typeof(hashPrId) !== 'undefined' ||
              typeof(resolveFocusPrId) !== 'undefined';
          }
          if(needToResolveAndPopModal()) this.fetchResolveAndPopModal({prId: resolveFocusPrId});

      }

     }
  }

  render() {

    this.visitedCount++; this.visited['render_A'] = this.visitedCount;

    if( this.props.treeLoaded && this.stage.current && !this.props.isFanChart) {
      this.doEveryRenderWheneverStateHasTree();
    }

    this.visitedCount++; this.visited['render_B'] = this.visitedCount;

    const {
      canvasTop,
      canvasWidth,
      flipData,
      setPrId,
      fetchTree,
      isPedigree,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    // if(isMobilePhone()) canvasHeight += 10;

    const props = {
      flipData,
      canvasWidth,
      canvasHeight,
      canvasTop,
      assets,
      isPedigree,
    };

    if(isAndroidTablet()){
      canvasHeight += androidTabletBottomBar;
    }

    let canvasStyle = {
      position: 'absolute',
      left: `${ canvasSideMargin}px`,
      width: '100%',
      height: `${canvasHeight}px`
    };

    if( !isMobilePhone() ){
      canvasStyle = { ...canvasStyle,
        top: `${ ( isDevelopment ? canvasTopDevelopmentLocalHost: canvasTop)}px`,
      }
    }

    const stageBackgroundColor = this.getStageBackgroundColor().stageBackgroundColor;

    let stageWrapperStyle = {
      width: `${this.props.canvasWidth}px`,
      height: `${canvasHeight + 20}px`,
      background: stageBackgroundColor,
      position: 'absolute',
    };

    if( this.props.chartType === 'fan' ) {
      stageWrapperStyle = {
        ...stageWrapperStyle,
        height: `${canvasHeight + 300}px`,
      }
    }

    if( dualPedigreeMode ) {

      const partFlipPanelWidth = flipPanelWidth / 1.5;
      const moveHalfShift = partFlipPanelWidth / 2;
      const moveFullShift = partFlipPanelWidth;

      stageWrapperStyle = {
        ...stageWrapperStyle,
        transform:`translateX(${moveHalfShift }px)`,
        repeat:  this.getStageBackgroundColor().repeat,
        backgroundSize:  this.getStageBackgroundColor().size,
        backgroundPosition:  this.getStageBackgroundColor().position,
      }

      let divs = document.querySelectorAll('.desktopBoxControls');
        [].forEach.call(divs, function(div) {
          div.style.transform = `translateX(${moveFullShift }px)`
      });

    }

    const notificationStyle = {
      NotificationItem: {
        DefaultStyle: {
          height: ( isMobilePhone() ? '64' : '61') + 'px'
        },
      }
    }

    const displayDebug = isDevelopment || isSeinfeld ? 'none': 'none';
    const debugWidth = window.innerWidth /** .2*/;

    return (
          <Fragment>

            <div id='debugDiv5' style={{
              display: `${displayDebug}`,
              zIndex: 9999999999,
              width: `${debugWidth}px`,
              height: '20px',
              position: 'fixed',
              top: '100px',
              left: '0px',
              background: 'white',
              border: '2px solid red'
            }}>
           </div>
            <div id='debugDiv4' style={{
              display: `${displayDebug}`,
              zIndex: 9999999999,
              width: `${debugWidth}px`,
              height: '20px',
              position: 'fixed',
              top: '80px',
              left: '0px',
              background: 'white',
              border: '2px solid red'
            }}>
           </div>
            <div id='debugDiv3' style={{
              display: `${displayDebug}`,
              zIndex: 9999999999,
              width: `${debugWidth}px`,
              height: '20px',
              position: 'fixed',
              top: '60px',
              left: '0px',
              background: 'white',
              border: '2px solid red'
            }}>
            </div>
            <div id='debugDiv2' style={{
              display: `${displayDebug}`,
              zIndex: 9999999999,
              width: `${debugWidth}px`,
              height: '20px',
              position: 'fixed',
              top: '40px',
              left: '0px',
              background: 'white',
              border: '2px solid red'
            }}>
            </div>
            <div id='debugDiv1' style={{
              display: `${displayDebug}`,
              zIndex: 9999999999,
              width: `${debugWidth}px`,
              height: '20px',
              position: 'fixed',
              top: '20px',
              left: '0px',
              background: 'white',
              border: '2px solid blue'
            }}>
            </div>
            <div id='debugDiv0' style={{
              display: `${displayDebug}`,
              zIndex: 9999999999,
              width: `${debugWidth}px`,
              height: '20px',
              position: 'fixed',
              top: '0px',
              left: '0px',
              background: 'white',
              border: '2px solid blue'
            }}>
            </div>
            <div id="canvas" style={canvasStyle}>

                  {  this.props.chartType === 'fan'

                      ?

                    <div ref="stageWrapper"  id="stageWrapper" style={stageWrapperStyle}>
                      <Stage
                        ref={this.stage}
                        x={defaultFanChartStagePos.x}
                        y={defaultFanChartStagePos.y}
                        width={ window.innerWidth }
                        height={ canvasHeight + 300 }
                      >
                        <Layer>

                          <FanChart
                            stage={this.stage}
                            ref={this.fanChartComponent}
                            translatedLabels={this.translatedLabels}
                            whichSideTip={this.state.whichSideTip}

                            setDropOnNode={this.setDropOnNode.bind(this)}
                            setMoveDecisionPanelPos={this.setMoveDecisionPanelPos.bind(this)}

                            setPedigreeAddbox={this.setPedigreeAddbox.bind(this)}
                            hidePedigreeAddbox={this.hidePedigreeAddbox.bind(this)}
                            enableTouchmove={this.enableTouchmove.bind(this)}
                            fetchImmediateFamily={this.props.fetchImmediateFamily}
                            ancestors={this.props.preferences.get('ancestors')}
                            maxAncestorGen={this.props.maxAncestorGen}
                            stageBackgroundColor={stageBackgroundColor}
                            onClickedNode={this.onClickedNode.bind(this)}
                            fanChartData={this.props.fanChartData}
                            fanchartObj={this.props.fanchartObj}
                            cidsGrps={this.props.cidsGrps}
                            nodeObjs={this.props.nodeObjs}
                            uniqueFanChartChars={this.props.uniqueFanChartChars}
                            hashWidthsNamesForFanchart={this.props.hashWidthsNamesForFanchart}
                            refocusFanChart={this.refocusFanChart.bind(this)}
                            cursorBecomesMove={this.cursorBecomesMove.bind(this)}
                            cursorBecomesPointer={this.cursorBecomesPointer.bind(this)}
                            userTouchedNode={this.userTouchedNode.bind(this)}
                            setNodeForFlipFocus={this.setNodeForFlipFocus.bind(this)}
                            setFlipCardScreenIsOn={this.setFlipCardScreenIsOn.bind(this)}
                            setShowMobileFlipCard={this.setShowMobileFlipCard.bind(this)}
                          />

                        </Layer>
                      </Stage>
                    </div>

                      :

                    <div ref="stageWrapper"  id="stageWrapper" style={stageWrapperStyle}>
                      <Stage
                        className="stage"
                        ref={this.stage}
                        width={this.props.canvasWidth}
                        height={canvasHeight}
                      >

                          {

                            dualPedigreeMode || dualPedigreeLaunchOnDev

                              ?

                                  <Layer
                                    key={'dualPedigreePrintLayer'}
                                  >
                                        {

                                          this.dualPedigreeBackgroundUserPrefenrenceIsReady

                                          &&

                                          typeof(this.props.dualPedigreeObj) !== 'undefined' &&
                                          typeof(this.props.dualPedigreeObj.backgroundTextureFileName) !== 'undefined' &&
                                          typeof(dualPedigreeBackgroundHash[this.props.dualPedigreeObj.backgroundTextureFileName]) !== 'undefined'

                                                ?

                                             <Fragment>

                                                <Rect
                                                  fill="white"
                                                  width={stageDualPedigreeSizeObj.width}
                                                  height={stageDualPedigreeSizeObj.height}
                                                  offsetX={stageDualPedigreeSizeObj.offsetX}
                                                  offsetY={stageDualPedigreeSizeObj.offsetY}
                                                >
                                                </Rect>
                                                <Image
                                                  fillPatternImage={this.backgroundStageImg}
                                                  fillPatternRepeat={dualPedigreeBackgroundHash[( dualPedigreeLaunchOnDev ? defaultBackgroundTextureFileName : this.props.dualPedigreeObj.backgroundTextureFileName)].repeat}
                                                  offsetX={dualPedigreeBackgroundHash[( dualPedigreeLaunchOnDev ? defaultBackgroundTextureFileName : this.props.dualPedigreeObj.backgroundTextureFileName)].offsetX}
                                                  offsetY={dualPedigreeBackgroundHash[( dualPedigreeLaunchOnDev ? defaultBackgroundTextureFileName : this.props.dualPedigreeObj.backgroundTextureFileName)].offsetY}
                                                  scaleX={dualPedigreeBackgroundHash[( dualPedigreeLaunchOnDev ? defaultBackgroundTextureFileName : this.props.dualPedigreeObj.backgroundTextureFileName)].scale}
                                                  scaleY={dualPedigreeBackgroundHash[( dualPedigreeLaunchOnDev ? defaultBackgroundTextureFileName : this.props.dualPedigreeObj.backgroundTextureFileName)].scale}
                                                  width={(dualPedigreeBackgroundHash[( dualPedigreeLaunchOnDev ? defaultBackgroundTextureFileName : this.props.dualPedigreeObj.backgroundTextureFileName)].width)}
                                                  height={dualPedigreeBackgroundHash[( dualPedigreeLaunchOnDev ? defaultBackgroundTextureFileName : this.props.dualPedigreeObj.backgroundTextureFileName)].height}

                                                >
                                                </Image>

                                             </Fragment>

                                            :

                                          null


                                        }

                                  </Layer>


                            :

                                    null
                          }

                        <Layer key={'20220713'} >

                        {  this.state.treeIsVisable ? this.state.nextNodeForPruning === null  &&  !this.props.isPedigree

                            ?

                          this.UnionsComponentsArray

                            :

                          this.PedbranchComponentsLinesArray

                          :

                          null

                        }

                        {this.state.treeIsVisable ? this.HighlightNodesComponentsArray : null}
                        {this.state.treeIsVisable ? this.ShadowNodesComponentsArray : null}
                        {this.state.treeIsVisable && !this.props.isPedigree ? this.AddNodeComponentsArray : null}
                        {this.state.treeIsVisable && this.props.isPedigree && !minimal ? this.PedbranchComponentsAddTabArray : null}
                        {this.state.treeIsVisable ? this.NodesComponentsArray : null}
                        {this.state.treeIsVisable ? this.PicComponentArray : null}
                        {this.state.treeIsVisable && !this.props.isPedigree ? this.PruneTreeComponentsArray : null}
                        {this.state.treeIsVisable ? this.FrameBorderComponentsArray : null}
                        {this.state.treeIsVisable ? this.DeadbannerComponentArray : null}
                        {this.state.treeIsVisable ? this.PresumedDeadbannerComponentArray : null}
                        {this.state.treeIsVisable ? this.FullNameComponentsArray : null}
                        {this.state.treeIsVisable ? this.DateAliveComponentsArray : null}
                        {this.state.treeIsVisable ? this.EditComponentsArray : null}
                        {this.state.treeIsVisable ? this.TransparentEditComponentsArray : null}
                        {this.state.treeIsVisable ? this.TreelinkComponentsArray : null}
                        {this.state.treeIsVisable ? this.TransparentTreeComponentsArray : null}
                        {this.state.treeIsVisable ? this.DnaBoxComponentsArray : null}
                        {this.state.treeIsVisable ? this.DnaComponentsArray : null}
                        {this.state.treeIsVisable ? this.GedcomComponentsArray : null}
                        {this.state.treeIsVisable ? this.GedcomTransparentBoxArray : null}
                        {this.state.treeIsVisable && !this.props.isPedigree ? this.DeleteComponentsArray : null}
                        {this.state.treeIsVisable ? this.GhostComponentArray : null}
                        {this.state.treeIsVisable ? this.CycleComponentsArray : null}
                        {this.state.treeIsVisable ? this.ResolveWarningComponentsArray : null}
                        {this.state.treeIsVisable ? this.TransparentResolveComponentsArray : null}
                        {this.state.treeIsVisable ? this.TransparentPendingMergeComponentsArray : null}
                        {this.state.treeIsVisable ? this.PendingMergeComponentsArray : null}
                        {this.state.treeIsVisable ? this.TransparentInconsistencyCircleArray : null}
                        {this.state.treeIsVisable ? this.InconsistencyCircleTextComponentsArray : null}
                        {this.state.treeIsVisable ? this.InconsistencyTextComponentsArray : null}
                        {this.state.treeIsVisable ? this.MatchesIconComponentsArray : null}
                        {this.state.treeIsVisable ? this.MatchesCountComponentsArray : null}
                        {this.state.treeIsVisable ? this.MagnifyCountComponentsArray  : null}
                        {this.state.treeIsVisable ? this.InviteComponentsArray  : null}
                        {this.state.treeIsVisable ? this.MultipleParentsComponentsArray : null}
                        {this.state.treeIsVisable ? this.MatchesBubbleComponentsArray : null}
                        {this.state.treeIsVisable ? this.ToolTipComponentsArray : null}
                        {this.state.treeIsVisable && !this.props.isPedigree ? this.NodeSpinnerArray : null}

                        { this.showDragNodeWhenCntrlKeyDn()  ? this.DragNode : null }

                        </Layer>
                      </Stage>
                    </div>

                  }




              { !isMobilePhone()  ? // DESKTOP HTML COMPONENTS

                <Fragment >

                {  this.state.pedigreeAddboxVisible               ? this.getPedigreeAddBoxCallout(): null     }
                {  this.state.printModalVisible                   ? this.getRenderPrintModalDesktop(): null     }
                {  this.state.showFloaterPanel && !this.props.isDualPedigree ?
                                                                    this.getRenderFloaterPanel(): null          }
                {  this.state.moveDecisionPanelVisible            ? this.getRenderMoveDecisionPanel(): null     }
                {  this.state.showMoveHelp                        ? this.getRenderMoveHelp(): null              }
                {  this.state.showInviteModal                     ? this.getRenderInviteModal(): null           }
                {  this.state.showLegendModal                     ? this.getLegendDesktop(): null               }
                {  this.showInititalProductTour()                 ? this.getRenderProductTour(): null           }
                {  typeof(this.props.preferences) !== 'undefined' ? this.getRenderPreferencesDesktop(): null    }
                {  this.state.dualPedigreeModalOpen               ? this.getRenderDualPedigreeCenterResizePicModal(): null }

                {  this.state.resolveIsVisable                    ? this.getRenderResolve(): null }
                {  this.state.dualPedigreeModalOpenChangeName     ? this.getRenderDualPedigreeChangeNameModal(): null }
                {  this.state.treeIsVisable && !this.props.isDualPedigree
                                                                  ? this.getRenderNotificationModal()     : null}
                {  !dualPedigreeMode && !dualPedigreeLaunchOnDev  ? this.getRenderFlipPanelDesktop(): null      }
                {  (userIsLoggedIn && dualPedigreeMode && this.props.focusNode ) ||
                    dualPedigreeLaunchOnDev                       ? this.getRenderDualPedigreePanel(): null       }

                {  userIsLoggedIn && this.state.showNavigationalControls && !dualPedigreeMode

                                                                  ? this.getRenderDesktopControlComponents(): null}
                {  userIsLoggedIn && dualPedigreeMode
                                                                  ? this.getDualPedigreeDownloadIcon(): null}


                {

                    this.didOnlyOnceAfterStateHasTree


                      ?


                      (


                         !userIsLoggedIn
                          || this.props.isPedigree
                          || isMobilePhone()
                          || minimal
                          || this.props.isFanChart
                          || (!this.state.gotoComponentEnabled && typeof(this.props.nodeObjs) === 'undefined')

                          ? null: this.getRenderNavigation()


                      )

                      :

                    null



                  }

                </Fragment >

                    :

                // Mobile HTMLCOMPONENTS

                <Fragment >

                  {  this.state.treeIsVisable ? this.getRenderNotificationModal()     : null }                                                       }

                  {  this.state.showFloaterPanel ? this.getRenderFloaterPanel(): null }

                  {
                    this.state.modalOpen && this.state.whichModalScreen === 'Preferences' ? this.getRenderPreferencesMobile(): null
                  }

                  {
                    (this.state.showNavigationalControls && !dualPedigreeMode  && userIsLoggedIn) || (isDevelopment) ? this.getMobileTouchIcons(): null
                  }

                  {
                    this.state.showPrintMobile ? this.getPrintFlipcardMobile(): null
                  }

                  {
                    this.state.showConfirmMobile ? this.getConfirmMobile(): null
                  }

                  {
                    this.state.showMobileFlipCard &&
                    this.state.showSlideUpImmediateFamily ? this.getRenderSlideUpImmediateFam(): null
                  }

                  {
                    this.state.showMobileFlipCard &&
                    this.state.showMobileLegend ? this.getRenderSlideUpImmediateFam(): null
                  }

                  {
                    this.state.showMobileFlipCard &&
                    this.state.showSlideUpAddSourceCitation ? this.getRenderSlideUpAddSourceCitation(): null
                  }

                  {
                    this.state.showMobileFlipCard ? this.getRenderFlipCardMobile(): null
                  }

                </Fragment >

            }
        {
        /*
        *
        *
        *
        *
        * Progress Indicator
        *
        *
        *
        *
        */

          this.state.showProgressIndicator && !this.props.isFanChart
            ?
            <ProgressIndicator
              canvasTop={this.props.canvasTop}
              canvasWidth={this.props.canvasWidth}
            />
          :
          null
        }

        {

            typeof(this.props.progress) !== 'undefined' &&
            this.props.progress.get('show') &&
            this.state.gotoNavTabActive &&
            this.state.navigationPanelIsUp

          ?
              <ProgressBar
                progress={this.props.progress}
              />

          :

            null

        }

        {

        /*
        *
        *
        *
        *
        * Redraw Canvas Tree -- For reloading Tree from external JS call
        *
        *
        *
        *
        */

          this.state.reloadCanvasTree

            ?

          <RedrawCanvasTree
            {...props}
            setPrId={setPrId}
            fetchTree={fetchTree}
            callSetPageProfile={this.callSetPageProfile.bind(this)}
            gatherNodesToFetchMoreData={this.gatherNodesToFetchMoreData.bind(this)}
            fetchPrunesOnlyAfterDelay={this.fetchPrunesOnlyAfterDelay.bind(this)}
            showProgressIndicator={this.showProgressIndicator.bind(this)}
            hideProgressIndicator={this.hideProgressIndicator.bind(this)}
            zoomTo={this.zoomTo.bind(this)}
            resetFocusNode={this.resetFocusNode.bind(this)}
            panAnimateToNode={this.panAnimateToNode.bind(this)}
            teleportToNode={this.teleportToNode.bind(this)}
            setDidRequestLoadTreeToTrue={this.setDidRequestLoadTreeToTrue.bind(this)}
            setPushToHistory={this.setPushToHistory.bind(this)}
            unsetRedrawCanvasTree={this.unsetRedrawCanvasTree.bind(this)}
            prIdToRedraw={this.state.prIdToRedraw}
            prIdToTeleport={this.state.prIdToTeleport}
            unionIdDualPedigreeChoice={this.state.unionIdDualPedigreeChoice}
            dualPedigreeObj={this.props.dualPedigreeObj}
            nodeObjs={this.props.nodeObjs}
            setNextNodeForPruning={this.setNextNodeForPruning.bind(this)}
            zoomOutFromMobileFlipCard={this.zoomOutFromMobileFlipCard.bind(this)}
            resetReloadCanvasTree={this.resetReloadCanvasTree.bind(this)}
            postPoster={this.props.postPoster}
            fetchPreferences={this.props.fetchPreferences}
          />

          :
          null
        }

        <NotificationSystem ref="notificationSystem" style={notificationStyle}/>
        </div>
      </Fragment>
    );
  }
}
